import {TOrganizations} from "@/types/organizationTypes";
import {createSlice} from "@reduxjs/toolkit";

export const initialData = {
  name: "",
  id: "",
  description: "",
  owner_id: "",
};

export const initialState: {data: TOrganizations; isLoading: boolean} = {
  data: initialData,
  isLoading: false,
};

export const organizationSlice = createSlice({
  name: "organizationState",
  initialState,
  reducers: {
    setOrgData: (state, action) => {
      state.data = action.payload;
      if (action.payload?.id) {
        localStorage.setItem("selected_org_id", action.payload.id);
      }
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    clearOrgData: (state) => {
      state.data = initialData;
      state.isLoading = false;
      localStorage.removeItem("selected_org_id");
    },
  },
});

export const {setOrgData, setIsLoading, clearOrgData} =
  organizationSlice.actions;

export default organizationSlice;
